import { CheckOutlined, CloseOutlined, InfoCircleOutlined } from '@ant-design/icons'
import { Tooltip } from 'antd'

import { PureButton } from '../../../../common/ui/pure-button/pure-button'
import styles from '../tariff-page.module.scss'

type TariffCardProps = {
  title: any
  price: any
  subtitle: any
  description: any
  features: any
  footerText: any
  buttonText: any
  buttonType: any
  isHighlighted: any
}

export const TariffCard = ({
  title,
  price,
  subtitle,
  description,
  features,
  footerText,
  buttonText,
  buttonType,
  isHighlighted,
}: TariffCardProps) => {
  return (
    <div className={styles.tariffCard}>
      <div>
        <h3>{title}</h3>
        <div>
          <span>от</span>
          <span>{price}</span>
          <span>/ {subtitle}</span>
        </div>
        <p className="text-xs text-gray-400 mb-4">мес. за пользователя</p>

        <p className="text-sm text-gray-600 leading-relaxed font-medium mb-6">{description}</p>

        <hr className="border-gray-100 my-6" />

        <ul className="space-y-3.5 mb-8">
          {features.map((feature: any, index: number) => (
            <li
              key={index}
              className="flex items-start text-sm text-gray-700"
            >
              <span className="mr-2.5 mt-0.5 flex-shrink-0">
                {feature.included ? (
                  <CheckOutlined className={isHighlighted ? 'text-green-500' : 'text-purple-400'} />
                ) : (
                  <CloseOutlined className="text-gray-400 text-xs" />
                )}
              </span>
              <span className={!feature.included ? 'text-gray-400 line-through' : ''}>{feature.text}</span>
              {feature.hasTooltip ? (
                <Tooltip title={feature.tooltipText || 'Информация'}>
                  <InfoCircleOutlined className="ml-1.5 text-gray-400 cursor-pointer hover:text-gray-600 text-xs mt-1" />
                </Tooltip>
              ) : null}
            </li>
          ))}
        </ul>
      </div>

      {/* Футер карточки с кнопкой */}
      <div>
        <p className="text-xs text-gray-500 leading-relaxed whitespace-pre-line mb-6 min-h-[36px]">{footerText}</p>
        <PureButton
          className={`h-12 font-semibold text-sm rounded-lg tracking-wide uppercase ${
            buttonType === 'primary'
              ? 'bg-purple-600 hover:bg-purple-700 border-none'
              : 'border-purple-300 text-purple-600 hover:text-purple-700 hover:border-purple-400'
          }`}
          size="large"
          type={buttonType}
          block
        >
          {buttonText}
        </PureButton>
      </div>
    </div>
  )
}
